import HonjoFileLink from './HonjoFileLink.vue'

export { HonjoFileLink }
